export const RUNTIME_BASE_URL = (() => {
  let value
  try {
    value = process.env.RUNTIME_BASE_URL
  } catch (e) {}
  return value || 'https://cloudflareworkers.com'
})()

export const DEVTOOLS_URL = (() => {
  let value
  try {
    value = process.env.DEVTOOLS_URL
  } catch (e) {}
  return (
    value ||
    localStorage.getItem('DEVTOOLS_URL') ||
    'https://cloudflareworkers.com/devtools-ui/95a05beae6f54001bea698cb79e2513819404ea0/cf_app.html'
  )
})()



// WEBPACK FOOTER //
// ./src/lib/config.ts